var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","to":{ name: 'add-self-return-shipment', params: { orderId: _vm.id }, }}},[_vm._v(" Новая накладная")])}
var staticRenderFns = []

export { render, staticRenderFns }